export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      const randomId = Math.random().toString(36).substring(2, 15);

      const getItems = () => {
        const items = document.querySelectorAll(`.carrousel-item-${randomId}`);
        return items;
      };

      //* Get the max index of the items
      const getMaxIndex = () => {
        const items = getItems();
        if (!items.length) {
          return 0;
        }
        /* mobile */
        if (window.innerWidth < 768) {
          return items.length;
        }
        /* tablet */
        if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
          return Math.round(items.length / 2);
        }
        /* desktop */
        if (window.innerWidth > 1024) {
          return Math.round(items.length / window.displayingItems);
        }
      };

      //* update the pagination index
      const changePaginationIndex = (type) => {
        const maxIndex = getMaxIndex();
        const newIndex =
          type === 'next'
            ? Math.min(window.activeIndex + 1, maxIndex - 1)
            : Math.max(window.activeIndex - 1, 0);

        window.activeIndex = newIndex;
        window.dragOffset = 0;
        window.startDrag = false;
        toggleButtonClasses();
        animateContainer();
      };

      const toggleButtonClasses = () => {
        const maxIndex = getMaxIndex();
        const nextButton = document.getElementById(`${randomId}-next-button`);
        const prevButton = document.getElementById(`${randomId}-prev-button`);

        //* prev button validations
        if (window.activeIndex === 0 && prevButton) {
          prevButton.classList.toggle('forbidden');
        }
        if (window.activeIndex > 0 && prevButton) {
          prevButton.classList.remove('forbidden');
        }
        //* next button validations
        if (window.activeIndex === maxIndex - 1 && nextButton) {
          nextButton.classList.toggle('forbidden');
        }
        if (window.activeIndex < maxIndex - 1 && nextButton) {
          nextButton.classList.remove('forbidden');
        }
      };

      const getWidthOffset = () => {
        if (window.innerWidth < 768) {
          return window.activeIndex * 16;
        }
        return 0;
      };

      const animateContainer = () => {
        const elementContainer = document.getElementById(
          `carrousel-container-${randomId}`,
        );
        const barContainer = document.getElementById(`${randomId}-pagination`);
        const widthOffset = getWidthOffset();
        if (window.activeIndex > getMaxIndex()) {
          window.activeIndex = getMaxIndex() - 1;
        }
        if (elementContainer) {
          elementContainer.style.transform = `translateX(calc(-${100 * window.activeIndex}% - ${widthOffset}px))`;
        }
        if (barContainer) {
          barContainer.style.left = `${window.activeIndex * 1}rem`;
        }
      };

      instance.data('Carrousel', (display) => {
        window.originalDisplayingItems = display;
        return {
          activeIndex: window.activeIndex,
          itemsLength: getMaxIndex(),
          randomId,
          getDisplayedItems() {
            animateContainer();
          },
          next() {
            changePaginationIndex('next');
          },
          prev() {
            changePaginationIndex('prev');
          },
          getPaginationIndex(index) {
            if (index === window.activeIndex) return;
            window.activeIndex = index;
            toggleButtonClasses();
            animateContainer();
          },
        };
      });

      const resizeItems = () => {
        toggleButtonClasses();
        animateContainer();
        const items = getItems();
        window.itemsLength = getMaxIndex();

        /* //*Adds the class to the items */
        items.forEach((item) => {
          if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
            window.displayingItems = 2;
            item.style.width = 'calc(50% - 1rem)';
            item.style.minWidth = 'calc(50% - 1rem)';
          }
          if (window.innerWidth > 1024) {
            window.displayingItems = window.originalDisplayingItems;
            item.style.width = `calc((100% / ${window.displayingItems}) - 1rem)`;
            item.style.minWidth = `calc((100% / ${window.displayingItems}) - 1rem)`;
          }
          if (window.innerWidth < 768) {
            window.displayingItems = 1;
            item.style.width = '100%';
            item.style.minWidth = '100%';
          }
        });
        /* Adds the class to the next button */
      };

      document.addEventListener('DOMContentLoaded', () => {
        window.activeIndex = 0;
        window.itemsLength = isNaN(getMaxIndex()) ? 0 : getMaxIndex();
        window.displayingItems = window.originalDisplayingItems;
        window.dragOffset = 0;
        window.startDrag = false;
        resizeItems();
      });

      window.onresize = resizeItems;
    });
  },
};
